import { render } from "./affiliate-review-page-self-assessment.vue?vue&type=template&id=00117a74&scoped=true&ts=true"
import script from "./affiliate-review-page-self-assessment.vue?vue&type=script&lang=ts"
export * from "./affiliate-review-page-self-assessment.vue?vue&type=script&lang=ts"

import "./affiliate-review-page-self-assessment.vue?vue&type=style&index=0&id=00117a74&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00117a74"]])

export default __exports__